<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs
          v-model="deviceGroupId"
          :modelId="modelId"
          :serialNo="serialNo"
          @click_breadCrumbs="selectedGroupChange"
          @click_breadCrumbsDevice="selectedDeviceChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <!-- データ追加用モーダル -->
      <div class="text-center">
        <v-dialog v-model="adddialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ $t('add') }}
            </v-card-title>
            <v-form
              v-model="dialogaddvalid"
              @submit.prevent="
                createData(
                  cleatDataMachine,
                  cleatDataLanguage,
                  cleatDataMail,
                  cleatDataUserName,
                  isAddActiveE,
                  isAddActiveC,
                  isAddActiveM
                )
              "
              ref="addForm"
            >
              <v-col cols="12">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="cleatDataMachine"
                    :items="machines"
                    :label="$t('serialNo')"
                    item-text="name_locale1"
                    return-object
                    outlined
                    block
                    v-if="!this.user_info.admin"
                  ></v-select>
                </v-col>
                <v-col class="ModalText" cols="12">
                  <v-text-field v-if="this.user_info.admin" :value="urlName" solo disabled> </v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="cleatDataLanguage"
                    :items="languages"
                    :label="$t('language')"
                    item-text="la"
                    return-object
                    outlined
                  ></v-select>
                </v-col>
                <v-text-field
                  :label="$t('mailAddress')"
                  outlined
                  v-model="cleatDataMail"
                  :rules="
                    countValid({
                      num: 0,
                      msg1: $t('requiredField'),
                      msg2: $t('pleaseEnterWithinCharacters', { num: 0 }),
                    })
                  "
                  required
                ></v-text-field>
                <v-text-field :label="$t('name')" outlined v-model="cleatDataUserName" required></v-text-field>
                <v-label>{{ $t('alarmLevel') }}</v-label
                ><br />
                <v-btn :color="lassColorSet(isAddActiveE)" @click="isAddActiveE = !isAddActiveE" class="selectAlermBtn">
                  E
                </v-btn>
                <v-btn :color="lassColorSet(isAddActiveC)" @click="isAddActiveC = !isAddActiveC" class="selectAlermBtn">
                  C
                </v-btn>
                <v-btn :color="lassColorSet(isAddActiveM)" @click="isAddActiveM = !isAddActiveM" class="selectAlermBtn">
                  M
                </v-btn>
              </v-col>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text type="submit" :disabled="!dialogaddvalid">
                  {{ $t('save') }}
                </v-btn>
                <v-btn color="primary" text @click="createDatacloseWindow">
                  {{ $t('cancel') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-col>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="items"
          item-key="id"
          height="70vh"
          class="v-data-table-outlined"
          fixed-header
          disable-pagination
          hide-default-footer
          show-select
          mt-5
        >
          <template v-slot:top>
            <v-toolbar flat dense>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <!--データ削除ボタン-->
                  <v-btn
                    @click="openDelete"
                    color="red"
                    :disabled="selected.length === 0"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('delete') }}</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <!-- データ追加用ボタン -->
                  <v-btn icon color="blue" @click="createDataModal" v-bind="attrs" v-on="on"
                    ><v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('add') }}</span>
              </v-tooltip>
            </v-toolbar>
          </template>
          <template v-slot:[`item.text`]="{ item }">
            <div v-if="!item.edit">
              {{ item.text }}
            </div>
          </template>
          <!-- データ編集ボタン -->
          <template v-slot:[`item.modify`]="{ item }">
            <v-btn
              icon
              @click="
                clickModify(item.id, item.mail, item.user_name, item.language, item.serial_no_edit, item.severity)
              "
              color="green"
              class="icon"
              fab
              small
              dark
            >
              <v-icon>mdi-circle-edit-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <!-- データ編集ボタン -->
        <v-dialog v-model="first" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ $t('edit') }}
            </v-card-title>
            <v-form
              v-model="dialogeditvalid"
              @submit.prevent="
                editSaveData(editMail, editUserName, isActiveE, isActiveC, isActiveM, editLanguage, editMachines)
              "
              ref="editForm"
            >
              <v-col cols="12">
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="editMachines"
                    :items="machines"
                    :label="$t('serialNo')"
                    item-text="name_locale1"
                    return-object
                    outlined
                    block
                    v-if="!this.user_info.admin"
                  ></v-select>
                </v-col>
                <v-col class="ModalText" cols="12">
                  <v-text-field v-if="this.user_info.admin" :value="urlName" solo disabled> </v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="6">
                  <v-select
                    v-model="editLanguage"
                    :items="languages"
                    :label="$t('language')"
                    item-text="la"
                    return-object
                    outlined
                  ></v-select>
                </v-col>
                <v-text-field
                  :label="$t('mailAddress')"
                  outlined
                  v-model="editMail"
                  :rules="
                    countValid({
                      num: 0,
                      msg1: $t('requiredField'),
                      msg2: $t('pleaseEnterWithinCharacters', { num: 0 }),
                    })
                  "
                  required
                ></v-text-field>
                <v-text-field :label="$t('name')" outlined v-model="editUserName"></v-text-field>
                <v-label>{{ $t('alarmLevel') }}</v-label
                ><br />
                <v-btn :color="lassColorSet(isActiveE)" @click="isActiveE = !isActiveE" class="selectAlermBtn">
                  E
                </v-btn>
                <v-btn :color="lassColorSet(isActiveC)" @click="isActiveC = !isActiveC" class="selectAlermBtn">
                  C
                </v-btn>
                <v-btn :color="lassColorSet(isActiveM)" @click="isActiveM = !isActiveM" class="selectAlermBtn">
                  M
                </v-btn>
              </v-col>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="
                    editSaveData(editMail, editUserName, isActiveE, isActiveC, isActiveM, editLanguage, editMachines)
                  "
                  :disabled="!dialogeditvalid"
                >
                  {{ $t('save') }}
                </v-btn>
                <v-btn color="primary" text @click="editCloseWindow">
                  {{ $t('cancel') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="rast" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ rastCheckTitle }}
            </v-card-title>

            <v-card-text class="textLine">
              {{ rastCheckMessage }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="deleteDatas">
                {{ $t('delete') }}
              </v-btn>
              <v-btn color="primary" text @click="deleteCloseWindow">
                {{ $t('cancel') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // import { delete } from 'vue/types/umd'
  import { mapGetters } from 'vuex';
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  // import VTooltip from 'v-tooltip'
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {
      BreadCrumbs,
    },
    data: () => ({
      headers: [],
      items: [
        // {id:'1',groupNm: 'aaaaaa',delete:false,mail:'kobelink@kdl.co.jk',language:'日本語',alerm:'E'},
        //{id:4,text: '' ,displayFrom: '', displayTo: '', file:'',edit:false, delete:false, displayFromMenu: false, displayToMenu: false} // 新規追加用
      ],
      machines: [],
      languages: [],
      message: 'mdi-check-circle-outline',
      dialog: false,
      adddialog: false,
      first: false,
      rast: false,
      errorMessages: '',
      ex4: true,
      postItem: '',
      addGroupName: '',
      editMail: '',
      editUserName: '',
      editDataId: '',
      daleatDataslength: '',
      rastCheckMessage: '',
      rastCheckTitle: '',
      isActiveE: false,
      isActiveC: false,
      isActiveM: false,
      TsetAlerm: '',
      AsetAlerm: '',
      setAlerm: '',
      editLanguage: '',
      editMachines: '',
      beforEditGroupName: '',
      isAddActiveE: false,
      isAddActiveC: false,
      isAddActiveM: false,
      cleatDataMachine: '',
      cleatDataMail: '',
      cleatDataUserName: '',
      cleatDataLanguage: '',
      lan: '',
      alert: '',
      editGroupNameId: '',
      mailid: '',
      selected: [],
      dialogaddvalid: true,
      dialogeditvalid: true,
      mailIdlist: [],
      groupNameId: '',
      firstMailId: '',
      serialNoEdit: '',
      optionalInfoFirst: '',
      optionalInfosecond: '',
      sourceType: '',
      sourceFlag: '',
      modelId: '',
      serialNo: '',
      groupId: '',
      urlName: '',
      seekId: '',
      deviceGroupId: '',
      mailList: '',
    }),
    methods: {
      //編集ボタンのイベント
      async getUserDeviceAuthorities() {
        console.log(this.user_info.admin);
        const userDeviceAuthorities = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
          device_group_id: this.user_info.deviceGroupId,
          sort: 'optional_info_2,serial_no',
        });
        return userDeviceAuthorities;
      },
      clickModify(id, mail, userName, language, serialNoEdit, alerm) {
        console.log(id, mail, userName, language, serialNoEdit, alerm);
        if (mail != '') {
          this.dialogeditvalid = true;
        } else {
          this.dialogeditvalid = false;
        }
        if (alerm.indexOf('E') !== -1) {
          this.isActiveE = true;
        } else {
          this.isActiveE = false;
        }

        if (alerm.indexOf('C') !== -1) {
          this.isActiveC = true;
        } else {
          this.isActiveC = false;
        }

        if (alerm.indexOf('M') !== -1) {
          this.isActiveM = true;
        } else {
          this.isActiveM = false;
        }
        alerm.indexOf('E');
        console.log(serialNoEdit);
        this.first = true;
        this.editDataId = id;
        this.editMail = mail;
        this.editUserName = userName;
        this.editLanguage = language;
        this.beforEditGroupName = serialNoEdit;
        this.editMachines = serialNoEdit;
      },
      //編集キャンセルイベント
      editCloseWindow() {
        this.first = !this.first;
      },
      //編集保存イベント
      async editSaveData(mail, userName, E, C, M, language, machines) {
        const moment = require('moment');
        this.$store.commit('loading/start_loading');
        if (!this.user_info.admin) {
          if ((machines.alertdata != undefined || machines.alertdata != null) && machines.name_locale1 != 'ALL') {
            this.sourceFlag = '1';
            this.sourceType = machines.alertdata;
          } else if (machines == 'ALL' || machines.name_locale1 == 'ALL') {
            this.sourceFlag = '0';
            this.sourceType = this.user_info.deviceGroupId;
          } else {
            for (const machineData of this.machines) {
              if (machineData.name_locale1 == machines) {
                this.sourceFlag = '1';
                this.sourceType = machineData.alertdata;
              }
            }
          }
          if (language.la != undefined) {
            language = language.la;
          }
          console.log(E, C, M);
          if (E === true) {
            this.TsetAlerm = '3';
            this.AsetAlerm = 'E';
            if (C === true || M === true) {
              this.TsetAlerm = this.TsetAlerm + ',';
              this.AsetAlerm = this.AsetAlerm + ',';
            }
          }
          if (C === true) {
            this.TsetAlerm = this.TsetAlerm + '2';
            this.AsetAlerm = this.AsetAlerm + 'C';
            if (M === true) {
              this.TsetAlerm = this.TsetAlerm + ',';
              this.AsetAlerm = this.AsetAlerm + ',';
            }
          }
          if (M === true) {
            this.TsetAlerm = this.TsetAlerm + '1';
            this.AsetAlerm = this.AsetAlerm + 'M';
          }
          if (language.value === undefined) {
            if (language === this.$t('english')) {
              this.lan = {
                id: 'en',
                la: this.$t('english'),
                value: 'English',
              };
            } else if (language === this.$t('japanese')) {
              this.lan = {
                id: 'ja',
                la: this.$t('japanese'),
                value: 'Japanese',
              };
            } else {
              this.lan = {
                id: 'ch',
                la: this.$t('chinese'),
                value: 'Chinese',
              };
            }
          } else {
            this.lan = language;
          }
          const TputData = {
            id: this.items.filter((item) => item.id === this.editDataId)[0].mailid,
            inserted: this.user_info.userId,
            locale: this.lan.value,
            mail: mail,
            severity: this.TsetAlerm,
            source_flag: this.sourceFlag,
            source_type: this.sourceType,
            updated: this.user_info.userId,
            user_name: userName,
            version: this.items.filter((item) => item.id === this.editDataId)[0].version,
            update_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS'),
            insert_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS'),
          };
          console.log(TputData);
          const data = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists/' +
              this.items.filter((item) => item.id === this.editDataId)[0].mailid,
            'PUT',
            TputData
          );
          console.log(data);
          this.items.filter((item) => item.id === this.editDataId)[0].mail = mail;
          this.items.filter((item) => item.id === this.editDataId)[0].severity = this.AsetAlerm;
          this.items.filter((item) => item.id === this.editDataId)[0].language = this.lan;
          this.items.filter((item) => item.id === this.editDataId)[0].serial_no_edit = machines.name_locale1;
          this.items.filter((item) => item.id === this.editDataId)[0].source_type = this.sourceType;

          this.TsetAlerm = '';
          this.AsetAlerm = '';
          this.editDataId = '';
          this.editMail = '';
          this.editUserName = '';
          this.editGroupName = '';
          this.sourceType = '';
          this.sourceFlag = '';
          this.first = !this.first;
          this.getData();
          this.$store.commit('loading/end_loading');
        } else {
          if (language.la != undefined) {
            language = language.la;
          }
          console.log(E, C, M);
          if (E === true) {
            this.TsetAlerm = '3';
            this.AsetAlerm = 'E';
            if (C === true || M === true) {
              this.TsetAlerm = this.TsetAlerm + ',';
              this.AsetAlerm = this.AsetAlerm + ',';
            }
          }
          if (C === true) {
            this.TsetAlerm = this.TsetAlerm + '2';
            this.AsetAlerm = this.AsetAlerm + 'C';
            if (M === true) {
              this.TsetAlerm = this.TsetAlerm + ',';
              this.AsetAlerm = this.AsetAlerm + ',';
            }
          }
          if (M === true) {
            this.TsetAlerm = this.TsetAlerm + '1';
            this.AsetAlerm = this.AsetAlerm + 'M';
          }
          if (language.value === undefined) {
            if (language === this.$t('english')) {
              this.lan = {
                id: 'en',
                la: this.$t('english'),
                value: 'English',
              };
            } else if (language === this.$t('japanese')) {
              this.lan = {
                id: 'ja',
                la: this.$t('japanese'),
                value: 'Japanese',
              };
            } else {
              this.lan = {
                id: 'ch',
                la: this.$t('chinese'),
                value: 'Chinese',
              };
            }
          } else {
            this.lan = language;
          }
          if (this.seekId === this.$route.params.group_id) {
            this.sourceFlag = '0';
            this.sourceType = this.$route.params.group_id;
          } else {
            this.sourceFlag = '1';
            this.sourceType = this.$route.params.model_id + '$' + this.$route.params.serial_no;
          }
          console.log(this.seekId);
          const TputData = {
            id: this.items.filter((item) => item.id === this.editDataId)[0].mailid,
            inserted: this.user_info.userId,
            locale: this.lan.value,
            mail: mail,
            severity: this.TsetAlerm,
            source_flag: this.sourceFlag,
            source_type: this.sourceType,
            updated: this.user_info.userId,
            user_name: userName,
            version: this.items.filter((item) => item.id === this.editDataId)[0].version,
            update_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS'),
            insert_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS'),
          };
          console.log(TputData);
          const data = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists/' +
              this.items.filter((item) => item.id === this.editDataId)[0].mailid,
            'PUT',
            TputData
          );
          console.log(data);
          this.items.filter((item) => item.id === this.editDataId)[0].mail = mail;
          this.items.filter((item) => item.id === this.editDataId)[0].severity = this.AsetAlerm;
          this.items.filter((item) => item.id === this.editDataId)[0].language = this.lan;
          this.items.filter((item) => item.id === this.editDataId)[0].serial_no_edit = machines.name_locale1;
          this.items.filter((item) => item.id === this.editDataId)[0].source_type = this.sourceType;

          this.TsetAlerm = '';
          this.AsetAlerm = '';
          this.editDataId = '';
          this.editMail = '';
          this.editUserName = '';
          this.editGroupName = '';
          this.sourceType = '';
          this.sourceFlag = '';
          this.first = !this.first;
          this.getData();
          this.$store.commit('loading/end_loading');
        }
      },
      openDelete() {
        this.rast = !this.rast;
        this.daleatDataslength = this.selected.length;
        this.rastCheckMessage = this.$t('doYouWantToDeleteItCompletely');
        this.rastCheckTitle = this.$t('finalConfirmation');
      },
      //データ追加イベント
      createDataModal() {
        this.adddialog = !this.adddialog;
        this.isAddActiveE = true;
        this.isAddActiveC = true;
        this.isAddActiveM = true;
        this.cleatDataMail = '';
        this.cleatDataUserName = '';
        this.cleatDataLanguage = this.languages[0];
        this.cleatDataMachine = 'ALL';
      },
      //データ追加キャンセルイベント
      createDatacloseWindow() {
        this.adddialog = !this.adddialog;
        this.isAddActiveE = true;
        this.isAddActiveC = true;
        this.isAddActiveM = true;
        this.cleatDataMail = '';
        this.cleatDataUserName = '';
        this.cleatDataLanguage = '';
        this.cleatDataMachine = '';
      },
      groupAuthritesInit() {
        return this.$store.getters['groupAuthorities/getInitialized']();
      },
      //データ追加保存イベント
      async createData(machines, language, mail, userName, alermE, alermC, alermM) {
        this.$store.commit('loading/start_loading');
        const moment = require('moment');
        if (!this.user_info.admin) {
          console.log(machines);
          if ((machines.alertdata != undefined || machines.alertdata != null) && machines.name_locale1 != 'ALL') {
            this.sourceFlag = '1';
            this.sourceType = machines.alertdata;
          } else if (machines == 'ALL' || machines.name_locale1 == 'ALL') {
            this.sourceFlag = '0';
            this.sourceType = this.user_info.deviceGroupId;
          } else {
            for (const machineData of this.machines) {
              if (machineData.name_locale1 == machines) {
                this.sourceFlag = '1';
                this.sourceType = machineData.alertdata;
              }
            }
          }
          if (alermE === true) {
            this.setAlerm = 'E';
            if (alermC === true || alermM === true) {
              this.setAlerm = this.setAlerm + ',';
              console.log(this.setAlerm);
            }
          }
          if (alermC === true) {
            this.setAlerm = this.setAlerm + 'C';
            if (alermM === true) {
              this.setAlerm = this.setAlerm + ',';
              console.log(this.setAlerm);
            }
          }
          if (alermM === true) {
            this.setAlerm = this.setAlerm + 'M';
          }
          this.alert = [];
          console.log(this.setAlerm);
          if (this.setAlerm.indexOf('E') != -1) {
            this.alert = this.alert + '3';
          }
          if (this.setAlerm.indexOf('C') != -1) {
            if (this.alert.length === 0) {
              this.alert = this.alert + '2';
            } else {
              this.alert = this.alert + ',2';
            }
          }
          if (this.setAlerm.indexOf('M') != -1) {
            if (this.alert.length === 0) {
              this.alert = this.alert + '1';
            } else {
              this.alert = this.alert + ',1';
            }
          }
          const source_type = 0;
          console.log(source_type);
          //東芝データの更新
          const postData = [
            {
              inserted: this.user_info.userId,
              locale: language.value,
              insert_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS') + 'Z',
              mail: mail,
              severity: this.alert,
              source_flag: this.sourceFlag,
              source_type: this.sourceType,
              update_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS') + 'Z',
              updated: this.user_info.userId,
              // user_name: this.user_info.userName,
              user_name: userName,
              version: 0,
            },
          ];
          console.log(postData);
          const mId = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists',
            'POST',
            postData
          );
          console.log(mId);
          this.adddialog = !this.adddialog;
          this.getData();
          this.$store.commit('loading/end_loading');
        } else {
          if (alermE === true) {
            this.setAlerm = 'E';
            if (alermC === true || alermM === true) {
              this.setAlerm = this.setAlerm + ',';
              console.log(this.setAlerm);
            }
          }
          if (alermC === true) {
            this.setAlerm = this.setAlerm + 'C';
            if (alermM === true) {
              this.setAlerm = this.setAlerm + ',';
              console.log(this.setAlerm);
            }
          }
          if (alermM === true) {
            this.setAlerm = this.setAlerm + 'M';
          }
          this.alert = [];
          console.log(this.setAlerm);
          if (this.setAlerm.indexOf('E') != -1) {
            this.alert = this.alert + '3';
          }
          if (this.setAlerm.indexOf('C') != -1) {
            if (this.alert.length === 0) {
              this.alert = this.alert + '2';
            } else {
              this.alert = this.alert + ',2';
            }
          }
          if (this.setAlerm.indexOf('M') != -1) {
            if (this.alert.length === 0) {
              this.alert = this.alert + '1';
            } else {
              this.alert = this.alert + ',1';
            }
          }
          console.log(this.seekId);
          if (this.seekId === this.$route.params.group_id) {
            this.sourceFlag = '0';
            this.sourceType = this.$route.params.group_id;
          } else {
            this.sourceFlag = '1';
            this.sourceType = this.$route.params.model_id + '$' + this.$route.params.serial_no;
          }
          //東芝データの更新
          const postData = [
            {
              inserted: this.user_info.userId,
              locale: language.value,
              insert_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS') + 'Z',
              mail: mail,
              severity: this.alert,
              source_flag: this.sourceFlag,
              source_type: this.sourceType,
              update_time: moment().format('YYYY-MM-DD HH:mm:ss.SSSSSSS') + 'Z',
              updated: this.user_info.userId,
              user_name: userName,
              version: 0,
            },
          ];
          console.log(postData);
          const mId = await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists',
            'POST',
            postData
          );
          console.log(mId);
          this.adddialog = !this.adddialog;
          this.getData();
          this.$store.commit('loading/end_loading');
        }
      },
      async deleteDatas() {
        console.log(this.selected);
        for (let s = 0; s < this.selected.length; s++) {
          await this.apiRequest(
            '/scadaapi/v1/master-info/info_alertmail_destination_lists/' + this.selected[s].mailid,
            'DELETE'
          );
        }
        this.getData();
        this.rast = !this.rast;
      },
      deleteCloseWindow() {
        this.rast = !this.rast;
      },
      async getData() {
        this.$store.commit('loading/start_loading');
        console.log('API取得開始');
        let machine = [];
        // let mgggg = await this.apiRequest('/scadaapi/v1/master-info/info_alertmail_destination_lists', 'GET')
        // console.log(mggg)
        let item = [];
        const currentGroup = await this.$store.getters['groupAuthorities/getGroup'](this.$route.params.group_id);
        console.log(currentGroup);
        //機械の情報の取得
        if (!this.user_info.admin) {
          const userDeviceAuthorities = await this.getUserDeviceAuthorities();
          const allMachinedata = {
            name_locale1: 'ALL',
            alertdata: this.user_info.deviceGroupId,
          };
          this.machines.push(allMachinedata);
          for (let a = 0; a < userDeviceAuthorities.length; a++) {
            const machine = await this.apiRequest('/v1/master-info/devices', 'GET', {
              model_id: userDeviceAuthorities[a].model_id,
              serial_no: userDeviceAuthorities[a].serial_no,
            });
            const machineData = {
              name_locale1: machine[0].name_locale1,
              alertdata: machine[0].model_id + '$' + machine[0].serial_no,
            };
            this.machines.push(machineData);
            this.mailList = await this.apiRequest('/scadaapi/v1/master-info/info_alertmail_destination_lists', 'GET', {
              updated: this.user_info.userId,
            });
          }
          this.seekId = this.$route.params.model_id + '$' + this.$route.params.serial_no;
        } else {
          if (this.$route.params.model_id !== undefined && this.$route.params.serial_no !== undefined) {
            machine = await this.apiRequest('/v1/master-info/devices', 'GET', {
              model_id: this.$route.params.model_id,
              serial_no: this.$route.params.serial_no,
            });
          }
          if (machine.length !== 0) {
            this.urlName = machine[0].name_locale1;
            this.seekId = this.$route.params.model_id + '$' + this.$route.params.serial_no;
          } else {
            this.urlName = this.$route.params.device_group_name_locale;
            this.seekId = this.$route.params.group_id;
          }
          console.log(machine);
          this.mailList = await this.apiRequest('/scadaapi/v1/master-info/info_alertmail_destination_lists', 'GET', {
            updated: this.user_info.userId,
            source_type: this.seekId,
          });
        }

        this.lan = [];
        this.alert = [];
        console.log(this.mailList);
        if (this.mailList != undefined && this.mailList != null) {
          for (const mailLists of this.mailList) {
            if (mailLists.source_type != this.user_info.deviceGroupId) {
              for (const machinData of this.machines) {
                console.log(machinData.alertdata, mailLists.source_type);
                if (machinData.alertdata == mailLists.source_type) {
                  this.serialNoEdit = machinData.name_locale1;
                }
              }
            } else {
              this.serialNoEdit = 'ALL';
            }

            if (mailLists.locale === 'English') {
              this.lan = {
                id: 'en',
                la: this.$t('english'),
                value: 'English',
              };
            } else if (mailLists.locale === 'Japanese') {
              this.lan = {
                id: 'ja',
                la: this.$t('japanese'),
                value: 'Japanese',
              };
            } else {
              this.lan = {
                id: 'ch',
                la: this.$t('chinese'),
                value: 'Chinese',
              };
            }
            this.alert = [];
            if (mailLists.severity.indexOf('3') != -1) {
              this.alert = this.alert + 'E';
            }
            if (mailLists.severity.indexOf('2') != -1) {
              if (this.alert.length === 0) {
                this.alert = this.alert + 'C';
              } else {
                this.alert = this.alert + ',C';
              }
            }
            if (mailLists.severity.indexOf('1') != -1) {
              if (this.alert.length === 0) {
                this.alert = this.alert + 'M';
              } else {
                this.alert = this.alert + ',M';
              }
            }
            item[item.length] = {
              id: this.$uuid.v4(),
              deviceGroupId: '',
              devices: '',
              groupName: {
                id: '',
                groupNm: '',
              },
              mailid: mailLists.id,
              insertTime: mailLists.insert_time,
              inserted: mailLists.inserted,
              language: {
                id: this.lan.id,
                la: this.lan.la,
                value: this.lan.value,
              },
              mail: mailLists.mail,
              user_name: mailLists.user_name,
              severity: this.alert,
              serial_no_edit: this.serialNoEdit,
              version: mailLists.version,
            };
          }
        }
        console.log(item);
        let smoll = 0;
        for (let h = 0; h < item.length; h++) {
          for (let g = h + 1; g < item.length; g++) {
            if (item[h].mailid > item[g].mailid) {
              smoll = item[h];
              item[h] = item[g];
              item[g] = smoll;
            }
          }
        }
        this.items = item;
        this.selected = [];
        this.$store.commit('loading/end_loading');
      },
      // パンくずリストクリック
      selectedGroupChange(group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
      selectedDeviceChange(device) {
        if (this.$route.name !== 'CompressorInfo') {
          this.$router.push({
            name: 'CompressorInfo',
            params: { model_id: device.model_id, serial_no: device.serial_no },
          });
        }
      },
    },
    computed: {
      lassColorSet() {
        return (value) => (value ? '#d3e6ff' : '#FFFFFF');
      },
      ...mapGetters('auth', ['user_info']),
      countValid: () => (val) => [(v) => !!v || val.msg1, (v) => !v || v.length >= val.num || val.msg2],
    },

    async created() {
      this.getData();
      if (!this.user_info.admin) {
        this.headers = [
          {
            text: this.$t('serialNo'),
            align: 'start',
            value: 'serial_no_edit',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('mailAddress'),
            align: 'start',
            value: 'mail',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('name'),
            align: 'start',
            value: 'user_name',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('language'),
            align: 'start',
            value: 'language.la',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('alarmLevel'),
            align: 'start',
            value: 'severity',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          { text: this.$t('edit'), align: 'start', value: 'modify', class: 'info-alerm-table-header', sortable: false },
        ];
      } else {
        this.headers = [
          {
            text: this.$t('mailAddress'),
            align: 'start',
            value: 'mail',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('name'),
            align: 'start',
            value: 'user_name',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('language'),
            align: 'start',
            value: 'language.la',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          {
            text: this.$t('alarmLevel'),
            align: 'start',
            value: 'severity',
            class: 'info-alerm-table-header',
            sortable: false,
          },
          { text: this.$t('edit'), align: 'start', value: 'modify', class: 'info-alerm-table-header', sortable: false },
        ];
      }
      // グループIDを設定
      let userDevice = [];
      console.log(this.$route.params.model_id, this.$route.params.serial_no);
      if (this.$route.params.model_id != undefined && this.$route.params.serial_no != undefined) {
        userDevice = await this.apiRequest('/v1/master-info/userDeviceAuthorities', 'GET', {
          model_id: this.$route.params.model_id,
          serial_no: this.$route.params.serial_no,
        });
      }
      const result = userDevice[0];
      if (result == undefined) {
        this.deviceGroupId = this.$route.params.group_id;
        this.modelId = this.$route.params.model_id;
        this.serialNo = this.$route.params.serial_no;
        console.log(this.$route.params.group_id);
      } else {
        this.deviceGroupId = result.device_group_id;
        this.modelId = this.$route.params.model_id;
        this.serialNo = this.$route.params.serial_no;
        console.log(result.device_group_id);
      }

      this.languages = [
        {
          id: 'ja',
          la: this.$t('japanese'),
          value: 'Japanese',
        },
        {
          id: 'en',
          la: this.$t('english'),
          value: 'English',
        },
        {
          id: 'ch',
          la: this.$t('chinese'),
          value: 'Chinese',
        },
      ];
    },
  };
</script>
<style>
  /* .addBtn{
    position:absolute;
    left:80%;
    margin-top:3vw;
  } */
  .v-icon.notranslate.labelcolor.material-icons.theme--light {
    color: #ffffff;
  }
  .saveBtnColor.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
    background-color: #09194f;
  }
  .span {
    margin-top: 7vw;
  }
  .TableStyleFirst {
    background-color: hsl(214, 100%, 78%);
  }
  .TableStyleSecond {
    background-color: hsl(214, 100%, 78%);
  }
  .TableStyle {
    border-right: 2px#d1cfcf solid !important;
    border-bottom: 2px #96c0e2 solid;
  }
  .TableStyleThird {
    border-bottom: 2px #96c0e2 solid;
  }

  .primary {
    background-color: #ffff;
  }
  .Btnstyle {
    color: #ffffff;
    height: 100% !important;
    width: 10px !important;
    padding: 0px !important;
  }
  .errormessages {
    margin-top: 20px;
    text-align: center;
  }
  .TableStyleBtn {
    width: 50px;
    text-align: center;
    border-right: 2px#d1cfcf solid !important;
    border-bottom: 2px #96c0e2 solid;
  }
  .Tablelanguage {
    width: 13vw;
    text-align: center;
    border-right: 2px#d1cfcf solid !important;
    border-bottom: 2px #96c0e2 solid;
  }
  .col {
    padding: 8px;
  }
  .selectAlermBtn {
    width: 33%;
  }
  .ModalText {
    width: 300px !important;
  }
  /* .v-data-table.v-data-table--dense.theme--light{
  height: auto;
} */
</style>
